import { SxProps, Theme } from "@mui/material";

import MobileAppsBG from "../../assets/images/mobile-apps-bg.png";

export const sideNavStyles: Record<string, SxProps<Theme>> = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "258px",
  },
  container: {
    display: "flex",
    padding: "24px 16px",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    borderRadius: "8px",
    border: "1px solid #E7E7E7",
    background: "#FFF",
  },
  avatarWrapper: {
    position: "relative",
  },
  avatar: {
    width: "80px",
    height: "80px",
  },
  verifiedIcon: {
    position: "absolute",
    top: "72px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: "10",
  },
  fullName: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    textAlign: "center",
    width: "100%",
  },
  about: {
    color: "var(--Dark---600, #707070)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "18px",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 3,
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
  },
  divider: {
    width: "100%",
    borderColor: "#EAECF0",
  },
  mobileAppsBox: {
    display: "flex",
    flexDirection: "column",
    gap: "11px",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(146deg, #00A76F 0%, #007867 100%)",
    borderRadius: "8px",
    padding: "252px 16px 24px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${MobileAppsBG})`,
  },
  mobileAppsTitle: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  mobileAppsDescription: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  mobileAppsLinksContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  storeLink: {
    height: "45px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50px",
    background: "#FFF",
    cursor: "pointer",
  },
  menuList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
  },
  menuItem: {
    position: "relative",
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    zIndex: "10",
    "& svg path": {
      stroke: "var(--Dark---600, #707070)",
    },
  },
  menuItemActive: {
    color: "var(--black-100, #1C1C1C)",
    fontWeight: 600,
    background: "#F5F6F5",
    "& svg path": {
      stroke: "#00A76F",
    },
  },
  menuItemWithIcon: {
    "&:hover": {
      backgroundColor: "#F5F6F5",
      fontWeight: 600,
      "& svg path": {
        stroke: "#00A76F",
      },
    },
  },
  menuItemBranch: {
    "&:before": {
      content: "''",
      position: "absolute",
      left: "-10px",
      transform: "translateY(-50%)",
      width: "24px",
      height: "12px",
      borderLeft: "2px solid #F6F6F6",
      borderBottom: "2px solid #F6F6F6",
      borderBottomLeftRadius: "12px",
      zIndex: "10",
    },
    "&:after": {
      content: "''",
      position: "absolute",
      left: "-10px",
      transform: "translateY(-50%)",
      width: "2px",
      height: "100%",
      backgroundColor: "#F6F6F6",
      zIndex: "1",
    },
  },
  menuItemButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 12px",
    borderRadius: "8px",
  },
  menuItemCollapse: {
    marginLeft: "30px",
  },
};
